// Define the states and provinces as constant arrays
const USA_STATES = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];
const CANADA_PROVINCES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];

/**
 * Returns a list of states or provinces based on the given country.
 * @param {string} country - The country to get the states or provinces for.
 * @returns {string[]} An array of states or provinces.
 */
export const getStates = (country = '') => {
  switch (country) {
    case 'USA':
    case 'US':
      return USA_STATES;
    case 'Canada':
      return CANADA_PROVINCES;
    default:
      return ['No Country'];
  }
};

export default getStates;
